import { useContext, useEffect, useState, useRef, useCallback } from "react"
import CheckoutHeader from "../../Component/Header/checkoutheader"
import DataContext from "../../Component/context"
import ApplyCoupanModal from "../../Component/Modals/apply_coupan"
import Login from "../../Component/Modals/login"
import { ApiService } from "../../Component/services/apiServices"
import constants from "../../Component/services/constants"
import AddItemModal from "../../Component/Modals/add_Item"
import Loader from "react-js-loader";
import sessionCartData from "../../Component/Element/cart_session_data"
import ChangeStoreModal from "../../Component/Modals/change_store_modal"
import { Swiper, SwiperSlide } from 'swiper/react';
import Skeleton from "react-loading-skeleton"
import AddressModal from "../../Component/Modals/address_modal"
import AddressListModal from "../../Component/Modals/address_list_modal"
import TimeSlotModal from "../../Component/Modals/time_slot_modal"
import moment from 'moment-timezone';
import { useNavigate } from "react-router-dom"
import { checkOrderProcess } from "../../Component/check_order_process"
import CartMenuItemsModal from "../../Component/Modals/cart_menu_items"
import { toast } from 'react-toastify'
const Checkout = () => {
    const timeZone = "Australia/Sydney";
    const navigate = useNavigate()
    const [orderNote, setOrderNote] = useState("");
    const [isLoading, setIsLoading] = useState(false)
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [shippingAmount, setShippingAmount] = useState(0)
    const [cart, setCart] = useState(() => {
        return JSON.parse(localStorage.getItem('CART_SESSION')) || [];
    });
    const [loadingItemId, setLoadingItemId] = useState(null);
    const contextValues = useContext(DataContext)
    const didMountRef = useRef(true);

    const dataArray = sessionCartData()
    const cartSummary = dataArray[3]
    const sliderProdRef = useRef(null);
    const loginModal = () => {
        contextValues.setToggleLoginModal(!contextValues.toggleLoginsModal)
    }

    const applycouponModal = () => {
        if (localStorage.getItem("USER_TOKEN")) {
            contextValues.setToggleApplyCoupanModal(!contextValues.toggleapplycoupanModal)
        } else {
            loginModal()
        }
    }
    
    const deliveryAmount = useCallback(() => {
        ApiService.fetchData('/setting-data').then((res) => {
            if (res.status === 'success') {
                const {
                    shipping_amount_tiffin,
                    shipping_amount_free
                } = res.data || {};
                let deliveryAmount = 0;
                //console.log('groupByDays()', groupByDays());

                groupByDays().forEach((itemDay) => {
                    let lunchMealsSum = itemDay.meals
                        .filter((item) => item.product_time === 'lunch')
                        .reduce((sum, item) => sum + (parseFloat(item.product_selling_price) + parseFloat(item.addon_amount)) * Number(item.quantity), 0);

                    let dinnerMealsSum = itemDay.meals
                        .filter((item) => item.product_time === 'dinner')
                        .reduce((sum, item) => sum + (parseFloat(item.product_selling_price) + parseFloat(item.addon_amount)) * Number(item.quantity), 0);

                    //console.log('lunchMealsSum', lunchMealsSum);
                    //console.log('dinnerMealsSum', dinnerMealsSum);
                    if (parseFloat(lunchMealsSum) > 0 && parseFloat(lunchMealsSum) < parseFloat(shipping_amount_free)) {
                        deliveryAmount += shipping_amount_tiffin ? parseFloat(shipping_amount_tiffin) : 0;
                    }
                    if (parseFloat(dinnerMealsSum) > 0 && parseFloat(dinnerMealsSum) < parseFloat(shipping_amount_free)) {
                        deliveryAmount += shipping_amount_tiffin ? parseFloat(shipping_amount_tiffin) : 0;
                    }
                });
                //console.log('deliveryAmount', deliveryAmount);
                setShippingAmount(deliveryAmount)
            }
        })
    }, []);

    const getPopularItems = useCallback(() => {
        setIsLoading(true);
        ApiService.fetchData("popular-item")
            .then((res) => {
                setIsLoading(false);
                if (res?.status === "success") {
                    const filteredItems = res?.data.filter(
                        (item) =>
                            item.product_type !== 1
                    );
                    contextValues.setaddonProductProduct(filteredItems);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching popular items:", error);
            });
    }, [contextValues]);

    const fetchaddress = useCallback(() => {
        ApiService.fetchData("get-address").then((res) => {
            if (res.status === "success") {
                if (res.resUserAddress.length > 0) {
                    contextValues.setSelectedAddress(res.rowAddressDefault);
                    localStorage.setItem('SELECTED_ADDRESS', JSON.stringify(res.rowAddressDefault));
                } else {
                    contextValues.setSelectedAddress({});
                    localStorage.removeItem('SELECTED_ADDRESS');
                }
            }
        })
    }, []);

    useEffect(() => {
        if (didMountRef.current) {
            fetchaddress()
            /* const sessionSelectedAddress = JSON.parse(localStorage.getItem("SELECTED_ADDRESS"));
            if (sessionSelectedAddress) {
                contextValues.setSelectedAddress(sessionSelectedAddress);
            } */
            const sessionSelectedCoupon = JSON.parse(localStorage.getItem("COUPON_SESSION"));
            if (sessionSelectedCoupon) {
                contextValues.setSelectedCoupon(sessionSelectedCoupon);
            }
            getPopularItems()
            deliveryAmount()
        }
        didMountRef.current = false;
    }, [getPopularItems, deliveryAmount, contextValues]);

    const groupByDays = () => {
        const cartSession = localStorage.getItem("CART_SESSION");
        const parsedCartSession = cartSession ? JSON.parse(cartSession) : [];
        const daywisemeals = parsedCartSession.reduce((acc, item) => {
            if (!acc[item.product_selected_date]) {
                acc[item.product_selected_date] = [];
            }
            acc[item.product_selected_date].push(item);
            return acc;
        }, {});

        const groupedArray = Object.keys(daywisemeals).map(day => ({
            day: day,
            meals: daywisemeals[day]
        }));

        groupedArray.sort((a, b) => {
            const dateA = new Date(a.day);
            const dateB = new Date(b.day);
            return dateA - dateB;  // Ascending order
        });

        return groupedArray;
    };

    const updateCartInSession = (updatedCart) => {
        localStorage.removeItem("COUPON_SESSION");
        const couponSession = localStorage.getItem("COUPON_SESSION");
        const parsedCouponSession = couponSession ? JSON.parse(couponSession) : {
            discount_amount: 0.0,
            promo_id: 0,
            promo_code: "",
        };
        contextValues.setSelectedCoupon(parsedCouponSession);
        localStorage.setItem('CART_SESSION', JSON.stringify(updatedCart));
        contextValues.setCartSessionData(updatedCart)
        contextValues.setCartCount(updatedCart.length)
        setCart(updatedCart);
        deliveryAmount()
        setTimeout(() => {

            setLoadingItemId(null)
        }, 500);

    };

    const changeStoreModal = () => {
        contextValues.setToggleChangeStoreModal(!contextValues.togglechangeStoreModal)
    }

    const onChangeRecieveStaus = (type) => {
        deleteCoupon();
        localStorage.removeItem("TIME_SLOT");
        const timeSlotData = null;
        localStorage.setItem('TIME_SLOT', JSON.stringify(timeSlotData));
        contextValues.setSelectedDateTime(timeSlotData);
        localStorage.setItem('OrderRecieveStatus', type)
        contextValues.setorderRecieveStatus(type)
    }

    /* Add, Plus , Minus & Remove to Cart  */
    const addToCart = (item) => {
        const cart = JSON.parse(localStorage.getItem('CART_SESSION')) || []
        setLoadingItemId(item.product_id)
        const existingItem = cart.find(cartItem => cartItem.product_id === item.product_id);
        let updatedCart;

        if (existingItem) {
            updatedCart = cart.map(cartItem =>
                cartItem.product_id === item.product_id
                    ? { ...cartItem, quantity: cartItem.quantity + 1 }
                    : cartItem
            );
        } else {
            let today = moment().tz(timeZone).format('YYYY-MM-DD');
            let currentDay = moment().tz(timeZone).format('dddd');
            const uniqueSessionId = crypto.randomUUID();
            let schedule = getScheduleTime(today)
            if (schedule === '') {
                today = moment().tz(timeZone).add(1, 'day').format('YYYY-MM-DD');
                currentDay = moment().tz(timeZone).add(1, 'day').format('dddd');
                schedule = getScheduleTime(today)
            }
            updatedCart = [
                ...cart,
                {
                    product_id: item.product_id,
                    product_day: currentDay,
                    product_selected_day: currentDay,
                    product_selected_date: today,
                    product_uniqueid: item.product_uniqueid,
                    product_name: item.product_name,
                    product_image: item.product_image,
                    product_price: item.product_price,
                    product_selling_price: item.product_selling_price,
                    product_discount: item.product_discounts,
                    product_type: item.product_type,
                    product_category_name: item.product_category_name,
                    product_tiffin_items: {},
                    product_slug: item?.product_slug,
                    addon_amount: 0,
                    addon_item_names: item.product_category_name,
                    quantity: 1,
                    product_sesion_id: uniqueSessionId,
                    product_time: schedule,
                },
            ];
        }
        updateCartInSession(updatedCart);
    }

    const getScheduleTime = (newDate = moment().tz(timeZone).format("YYYY-MM-DD")) => {
        const today = moment().tz(timeZone).format('YYYY-MM-DD');
        const selectedDate = newDate;

        if (today !== selectedDate) {
            contextValues.setMenuSchedule('lunch');
            return 'lunch';
        }

        if (!contextValues?.settingData) {
            contextValues.setMenuSchedule('lunch');
            return 'lunch';
        }

        const { lunch_end_time, dinner_end_time, pickup_lunch_end_time, pickup_dinner_end_time } = contextValues.settingData;
        const currentTime = moment().tz(timeZone).format('HH:mm:ss');

        const isDelivery = contextValues.orderRecieveStatus === 'delivery';
        const lunchEnd = isDelivery ? lunch_end_time : pickup_lunch_end_time;
        const dinnerEnd = isDelivery ? dinner_end_time : pickup_dinner_end_time;

        const schedule = currentTime < lunchEnd ? 'lunch' : currentTime < dinnerEnd ? 'dinner' : '';
        contextValues.setMenuSchedule(schedule);
        return schedule;
    };

    const minusToCart = (item) => {
        const cart = JSON.parse(localStorage.getItem('CART_SESSION')) || [];
        setLoadingItemId(item.product_id);
        const existingItem = cart.find(cartItem => cartItem.product_id === item.product_id);
        if (existingItem) {
            let updatedCart;
            if (existingItem.quantity > 1) {
                updatedCart = cart.map(cartItem =>
                    cartItem.product_id === item.product_id
                        ? { ...cartItem, quantity: cartItem.quantity - 1 }
                        : cartItem
                );
            } else {
                updatedCart = cart.filter(cartItem => cartItem.product_id !== item.product_id);
            }
            updateCartInSession(updatedCart);
        }
    };

    const cartSummaryPlus = (index) => {
        const cart = JSON.parse(localStorage.getItem('CART_SESSION')) || [];
        setLoadingItemId(index);
        const existingItem = cart.find((_, cartIndex) => cartIndex === index);

        if (existingItem) {
            const updatedCart = cart.map((cartItem, cartIndex) =>
                cartIndex === index
                    ? { ...cartItem, quantity: cartItem.quantity + 1 }
                    : cartItem
            );
            updateCartInSession(updatedCart);
        }
    };

    const cartSummaryRemove = (index) => {
        const cart = JSON.parse(localStorage.getItem('CART_SESSION')) || [];
        if (index >= 0 && index < cart.length) {
            const updatedCart = cart.filter((_, cartIndex) => cartIndex !== index);
            updateCartInSession(updatedCart);
        }
    };

    const cartSummaryMinus = (index) => {
        const cart = JSON.parse(localStorage.getItem('CART_SESSION')) || [];
        setLoadingItemId(index);
        const existingItem = cart.find((_, cartIndex) => cartIndex === index);
        if (existingItem) {
            let updatedCart;
            if (existingItem.quantity > 1) {
                updatedCart = cart.map((cartItem, cartIndex) =>
                    cartIndex === index
                        ? { ...cartItem, quantity: cartItem.quantity - 1 }
                        : cartItem
                );
            } else {
                updatedCart = cart.filter((_, cartIndex) => cartIndex !== index);
            }
            updateCartInSession(updatedCart);
        }
    };

    /* ADDRESS SECTION  */
    const addressModal = () => {
        contextValues.setToggleAddressModal(!contextValues.toggleAddressModal)
    }

    const addressListModal = () => {
        contextValues.setToggleAddressListModal(!contextValues.toggleAddressListModal)
    }

    const deleteCoupon = () => {
        localStorage.removeItem("COUPON_SESSION");
        const couponSession = localStorage.getItem("COUPON_SESSION");
        const parsedCouponSession = couponSession ? JSON.parse(couponSession) : {
            discount_amount: 0.0,
            promo_id: 0,
            promo_code: "",
        };
        contextValues.setSelectedCoupon(parsedCouponSession);
    }

    const goToPayment = async () => {
        const validation = await checkOrderProcess(contextValues);
        if (validation) {
            let shippingCharge = 0;
            let couponCharge = 0;

            if (contextValues.orderRecieveStatus === 'delivery') {
                shippingCharge = parseFloat(shippingAmount || 0);
            }

            if (contextValues.selectedCoupon?.promo_id > 0) {
                couponCharge = parseFloat(contextValues.selectedCoupon?.discount_amount || 0);
            }

            const finalAmount = parseFloat(cartSummary?.total_amount || 0) + parseFloat(shippingCharge) - parseFloat(couponCharge);
            if (finalAmount > 0) {
                navigate('/payment', { state: { order_note: orderNote, shippingAmount: shippingAmount, store: contextValues.selectedStore } })
            } else {
                const validation = await checkOrderProcess(contextValues);
                if (validation) {
                    const dataString = {
                        cart_session_data: contextValues.cartSessionData,
                        store_data: contextValues.selectedStore,
                        coupon_session_data: contextValues.selectedCoupon,
                        cart_summary_data: cartSummary,
                        address_session: contextValues.selectedAddress,
                        trans_payment: finalAmount.toFixed(2),
                        ua_id: contextValues.orderRecieveStatus === 'delivery' ? contextValues.selectedAddress.ua_id : 0,
                        trans_payment_method: 'wallet',
                        delivery_type: contextValues.orderRecieveStatus === 'delivery' ? 1 : 0,
                        trans_shipping_amount: shippingCharge,
                        total_discount_amount: parseFloat(cartSummary.discount),
                        order_note: orderNote,
                        trans_order_on: 'MOBILE',
                    }
                    setSpinnerLoading(true)
                    ApiService.postData('create-freeitem-transaction', dataString).then((res) => {
                        if (res.status === 'success') {
                            localStorage.removeItem("ADDRESS_SESSION");
                            localStorage.removeItem("COUPON_SESSION");
                            localStorage.removeItem("CART_SESSION");
                            setSpinnerLoading(false)
                            navigate('/thankyou/' + res.orderid)
                        } else {
                            setSpinnerLoading(false)
                            toast.error(res.message)
                        }
                    })
                }
            }
            //  navigate('/payment', { state: { order_note: orderNote, shippingAmount: shippingAmount, store: contextValues.selectedStore } })
        }
    }
    const toggleCartMenuItemsModal = (items) => {
        contextValues.setCartMenuItems(items)
        contextValues.setCartMenuItemsModal(!contextValues.toggleCartMenuItems)
    }
    console.log('=>', contextValues.settingData);

    return (
        <>
            <CheckoutHeader heading={'Checkout'} step={'2'} />
            <div id="appCapsule">
                {contextValues.cartCount > 0 ?
                    <>
                        {/* Cart summary */}
                        {contextValues.cartSessionData && contextValues.cartSessionData?.length > 0 &&
                            <div className="checkbox">
                                <div className="checkbox-body">
                                    {contextValues.cartSessionData?.map((item, index) => (
                                        <div className="checkproduct" key={index}>
                                            <div className="checkproductMedia">
                                                <img alt="Daadi's Kitchen" src={item?.product_image ? item?.product_image : constants.Default_image}></img>
                                            </div>
                                            <div className="checkproductContent">
                                                <div className="chkp_header">
                                                    <div className="chkp_header_left">
                                                        <h6 className="mb-1">{item?.product_name}</h6>
                                                        {item?.product_type === 1 && <div className="Vdetails" onClick={() => toggleCartMenuItemsModal(item)}>View Details <i class="ri-arrow-right-wide-line"></i></div>}
                                                    </div>
                                                    <div className="chkp_header_right">
                                                        <div className="itemPrice itemPrice_cart">
                                                            {parseFloat(item.product_selling_price) && (
                                                                <ins className="new-price">
                                                                    ${((parseFloat(item.product_selling_price) + parseFloat(item.addon_amount)) * item?.quantity).toFixed(2)}
                                                                </ins>
                                                            )}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="chkp_footer">
                                                    <div onClick={() => { cartSummaryRemove(index) }}>
                                                        <a href="javascript:void(0);" className="checkremove">
                                                            <i className="ri-delete-bin-6-line"></i> Remove
                                                        </a>
                                                    </div>

                                                    <div className="itemQty itwqty_small">
                                                        {loadingItemId === index ? (
                                                            <span>
                                                                <Loader type="spinner-default" bgColor={'#db2727'} color={'#db2727'} size={20} />
                                                            </span>
                                                        ) : (
                                                            <>
                                                                <span onClick={() => { cartSummaryMinus(index) }}><i className="ri-subtract-line"></i></span>
                                                                <span>{item?.quantity}</span>
                                                                <span onClick={() => { cartSummaryPlus(index) }}><i className="ri-add-line"></i></span>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }

                        {/* Order total */}
                        <div className="checkbox">
                            <div className="checkbox-header">
                                <h5>Order total</h5>
                            </div>
                            <div className="checkbox-body">
                                <ul className="paymentSummary">
                                    <li>
                                        <span>Subtotal</span>
                                        <span>${parseFloat(cartSummary?.itemTotal)?.toFixed(2)}</span>
                                    </li>
                                    <li>
                                        <span>Discount</span>
                                        <span className="tx-green">-${parseFloat(cartSummary?.discount)?.toFixed(2)}</span>
                                    </li>
                                    <li>
                                        <span>Add On</span>
                                        <span >${parseFloat(cartSummary?.addon_amount)?.toFixed(2)}</span>
                                    </li>
                                    {contextValues.selectedCoupon.promo_id > 0 && <li>
                                        <span>Coupon Discount</span>
                                        <span className="tx-green">-${parseFloat(contextValues.selectedCoupon.discount_amount)?.toFixed(2)}</span>
                                    </li>}
                                    {contextValues.orderRecieveStatus === 'delivery' && parseFloat(shippingAmount) > 0 &&
                                        <li>
                                            <span>Shipping Charge</span>
                                            <span>${parseFloat(shippingAmount)?.toFixed(2)}</span>
                                        </li>
                                    }
                                    <li className="fw600">
                                        <span>Total Amount</span>
                                        <span>
                                            ${(() => {
                                                let shippingCharge = 0;
                                                let couponCharge = 0;

                                                if (contextValues.orderRecieveStatus === 'delivery') {
                                                    shippingCharge = parseFloat(shippingAmount || 0);
                                                }

                                                if (contextValues.selectedCoupon?.promo_id > 0) {
                                                    couponCharge = parseFloat(contextValues.selectedCoupon?.discount_amount || 0);
                                                }

                                                const finalAmount =
                                                    parseFloat(cartSummary?.total_amount || 0) + parseFloat(shippingCharge) - parseFloat(couponCharge);

                                                return finalAmount.toFixed(2);
                                            })()}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="checkbox mb-15">
                            <div className="checkbox-header">
                                <h5>Add Order Note</h5>
                            </div>
                            <div className="checkbox-body">
                                <div className="pickupaddrees">
                                    <textarea
                                        style={{
                                            border: "1px solid #e3e7ed",
                                            borderRadius: "5px",
                                            height: "100px",
                                            width: "100%",
                                        }}
                                        value={orderNote} // Controlled Component
                                        onChange={(e) => setOrderNote(e.target.value)} // Update State
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        {/* Coupon Section */}
                        {contextValues.selectedCoupon.promo_id > 0 ?
                            <div className="applycouponsbox" >
                                <i className="ri-discount-percent-line ri-2x"></i>
                                <div>
                                    <h6 className="mb-0">{contextValues.selectedCoupon.promo_code} Applied</h6>
                                    <p className="mb-0 tx-12 tx-primary">You saved additional ${parseFloat(contextValues.selectedCoupon.discount_amount).toFixed(2)}</p>
                                </div>
                                <i className="ri-delete-bin-line ml-auto ri-xl" onClick={() => { deleteCoupon() }}></i>
                            </div>
                            :
                            <div className="applycouponsbox mb-0" onClick={() => { applycouponModal() }}>
                                <i className="ri-discount-percent-line ri-2x"></i>
                                <div>
                                    <h6 className="mb-0">Apply coupon</h6>
                                    <p className="mb-0 tx-12 tx-primary">Save more with coupons available for you</p>
                                </div>
                                <i className="ri-arrow-right-s-line ml-auto ri-xl"></i>
                            </div>
                        }




                        {/* Frequently added together */}
                        {isLoading ?
                            <>
                                <div className="checkbox">
                                    <div className="checkbox-header">
                                        <h5><Skeleton width={'200px'}></Skeleton></h5>
                                    </div>
                                    <div className="checkbox-body">
                                        <div className="container">
                                            <div className="row">
                                                {Array(3).fill().map((_, index) => (
                                                    <div className="col-4" key={index}>
                                                        <div className="feturesItems" key={index}>
                                                            <div >
                                                                <Skeleton height={100} width="100%" />
                                                            </div>
                                                            <div className="feturesItemsContent">

                                                                <Skeleton width={"60px"} />

                                                                <div className="itemPrice mb-10">
                                                                    <Skeleton width={"40px"} />
                                                                </div>
                                                                <div className="itemQty itemQtySmall">
                                                                    <Skeleton width={'80px'} height={'20px'} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            contextValues.addonProduct && contextValues.addonProduct?.length > 0 &&
                            <>
                                <div className="checkbox" style={{ marginBottom: '260px' }}>
                                    <div className="checkbox-header">
                                        <h5>Frequently added together</h5>
                                    </div>
                                    <div className="checkbox-body frequently mt-15">
                                        <Swiper
                                            spaceBetween={10}
                                            slidesPerView={2.5}
                                            pagination={{
                                                clickable: true,
                                            }}
                                            navigation={false}
                                            ref={sliderProdRef}
                                        >
                                            {contextValues.addonProduct?.map((item, popindex) => {
                                                // Check if the item exists in the cart
                                                const cartItem = cart.find(cartItem => cartItem.product_id === item.product_id);
                                                const itemQuantity = cartItem ? cartItem.quantity : 0; // Extract quantity if exists

                                                return (
                                                    <SwiperSlide key={popindex}>
                                                        <div className="feturesItems" key={popindex}>
                                                            <div className="feturesItemsImg">
                                                                <img
                                                                    src={item?.product_image ? item?.product_image : constants.Default_image}
                                                                    alt={item?.product_name}
                                                                    style={{ width: '100%' }}
                                                                />
                                                            </div>
                                                            <div className="feturesItemsContent">
                                                                <h2 className="title">{item?.product_name}</h2>
                                                                <div className="itemPrice mb-10">
                                                                    {parseFloat(item.product_selling_price) && (
                                                                        <ins className="new-price">
                                                                            ${parseFloat(item.product_selling_price)?.toFixed(2)}
                                                                        </ins>
                                                                    )}
                                                                    {parseFloat(item.product_price) > parseFloat(item.product_selling_price) && (
                                                                        <del className="old-price">
                                                                            ${parseFloat(item.product_price)?.toFixed(2)}
                                                                        </del>
                                                                    )}
                                                                </div>
                                                                <div className="itemQty itemQtySmall">
                                                                    {loadingItemId === item.product_id ? (
                                                                        <span>
                                                                            <Loader type="spinner-default" bgColor={'#db2727'} color={'#db2727'} size={20} />
                                                                        </span>
                                                                    ) : (
                                                                        cartItem && itemQuantity > 0 ? (
                                                                            <>
                                                                                <span onClick={() => { minusToCart(item) }}><i className="ri-subtract-line"></i></span>
                                                                                <span>{itemQuantity}</span>
                                                                                <span onClick={() => { addToCart(item) }}><i className="ri-add-line"></i></span>
                                                                            </>
                                                                        ) : (
                                                                            <span onClick={() => { addToCart(item); }}>
                                                                                Add
                                                                            </span>
                                                                        )

                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                );
                                            })}
                                        </Swiper>
                                    </div>

                                </div>
                            </>
                        }
                        {contextValues.UserToken ?
                            <div className="checkout-footer p-0">
                                <div className="checkout-footer-dev">
                                    <h6>Delivery & Pickup Details</h6>
                                    <div className="checkout-footer-dev-inner">
                                        <div className={`cftd_box ${contextValues.orderRecieveStatus === 'delivery' ? 'active' : ''}`} onClick={() => { onChangeRecieveStaus('delivery') }}>
                                            <h6 className="mb-0">Delivery</h6>
                                            <div className="pickupselect"><span></span></div>
                                        </div>
                                        <div className={`cftd_box ${contextValues.orderRecieveStatus === 'pickup' ? 'active' : ''}`} onClick={() => { onChangeRecieveStaus('pickup') }}>
                                            <h6 className="mb-0">Pickup</h6>
                                            <div className="pickupselect"><span></span></div>
                                        </div>
                                    </div>
                                    {contextValues.orderRecieveStatus === 'pickup' &&
                                        <div className="checkout-footer-map">
                                            <iframe src={`https://www.google.com/maps/embed/v1/place?q=${encodeURIComponent(contextValues?.selectedStore?.store_address)}&key=AIzaSyAE7oxhbgUxiIzikhCeN6TB6UUe1frQnZs`} width="100%" height="100%" allowFullScreen="" loading="lazy" title={`Map of ${contextValues?.selectedStore?.store_address}`} ></iframe>
                                        </div>
                                    }
                                </div>
                                {/* Pickup */}
                                {contextValues.orderRecieveStatus === 'pickup' &&
                                    <>
                                        <div className="checkout-footer-box">
                                            <div className="cgb_tetx">
                                                <div className="cgb_tetx_icon"><i className="ri-store-2-line"></i></div>
                                                <div className="cgb_tetx_tr">
                                                    <h6 className="mb-1">{contextValues?.selectedStore?.store_name}</h6>
                                                    <p className="mb-0 tx-14 eclips">{contextValues?.selectedStore?.store_address}</p>
                                                </div>
                                            </div>
                                            <div className="cgb_butotn">
                                                <button type="button" className="editbutton" onClick={(e) => changeStoreModal()}><i className="ri-pencil-line"></i></button>
                                            </div>
                                        </div>
                                    </>
                                }
                                {/* Delivery */}
                                {contextValues.orderRecieveStatus === 'delivery' &&
                                    <>
                                        <div className="checkout-footer-box">
                                            <div className="cgb_tetx">
                                                <div className="cgb_tetx_icon"><i className="ri-map-pin-line"></i></div>
                                                {contextValues.selectedAddress && contextValues.selectedAddress.ua_id ?
                                                    <div className="cgb_tetx_tr">
                                                        <h6 className="mb-1">{contextValues.selectedAddress.ua_address_type === 'Other' ? contextValues.selectedAddress.ua_address_type_other : contextValues.selectedAddress.ua_address_type}</h6>
                                                        <p className="mb-0 tx-14 eclips">
                                                            {[
                                                                contextValues.selectedAddress.ua_house_no,
                                                                contextValues.selectedAddress.ua_floor,
                                                                contextValues.selectedAddress.ua_complete_address,
                                                                contextValues.selectedAddress.ua_area,
                                                                contextValues.selectedAddress.ua_city_name,
                                                                contextValues.selectedAddress.ua_state_name,
                                                                contextValues.selectedAddress.ua_pincode,
                                                                contextValues.selectedAddress.ua_how_to_reach
                                                            ]
                                                                .filter(Boolean)
                                                                .join(", ")}
                                                        </p>
                                                    </div>
                                                    :
                                                    <div className="cgb_tetx_tr">
                                                        <h6 className="mb-1">Address</h6>
                                                        <p className="mb-0 tx-14 eclips">No address found please add address</p>
                                                    </div>
                                                }
                                            </div>
                                            {contextValues.selectedAddress && contextValues.selectedAddress.ua_id &&
                                                <div className="cgb_butotn">
                                                    <button type="button" className="editbutton" onClick={(e) => addressListModal()}><i className="ri-pencil-line"></i></button>
                                                </div>
                                            }
                                        </div>
                                    </>

                                }
                                {contextValues.orderRecieveStatus === 'pickup' ?
                                    <>
                                        <div className="p-15">
                                            <button type="button" className="btn btn-full btn-primary btn-lg" onClick={() => { goToPayment() }} disabled={spinnerLoading}>{spinnerLoading ? <img loading="lazy" src="/img/loder01.gif" width="60px" height="11px" /> : 'Proceed To Pay'}</button>
                                        </div>
                                    </>
                                    :
                                    <>
                                        {contextValues.selectedAddress && contextValues.selectedAddress.ua_id ?
                                            <div className="p-15">
                                                <button type="button" className="btn btn-full btn-primary btn-lg" onClick={() => { goToPayment() }} disabled={spinnerLoading}>{spinnerLoading ? <img loading="lazy" src="/img/loder01.gif" width="60px" height="11px" /> : 'Proceed To Pay'}</button>
                                            </div>
                                            :
                                            <div className="p-15">
                                                <button type="button" className="btn btn-full btn-primary btn-lg" onClick={(e) => addressModal()}>Add Address</button>
                                            </div>
                                        }
                                    </>
                                }
                            </div>
                            :
                            <div className="checkout-footer p-0">
                                <div className="p-15">
                                    <button type="button" className="btn btn-full btn-primary btn-lg" onClick={() => { loginModal() }}>Login/Sign up to proceed</button>
                                </div>
                            </div>
                        }
                    </>
                    :
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className='noimg text-center mt-5'>
                                    <img src='/img/emptycart.png' className='wd-150' alt="Daadi's Kitchen"></img>
                                    <h5>Your Cart is Empty</h5>
                                    <p>It looks like you haven't added any items to your cart yet.Your cart is waiting for items!</p>
                                    <a href='/' className='btn btn-outline-primary btn-md'>Continue Order</a>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            {contextValues.toggleapplycoupanModal && <ApplyCoupanModal></ApplyCoupanModal>}
            {contextValues.toggleLoginsModal && <Login></Login>}
            {contextValues.toggleItemAddModal && <AddItemModal></AddItemModal>}
            {contextValues.togglechangeStoreModal && <ChangeStoreModal></ChangeStoreModal>}
            {contextValues.toggleAddressModal && (<AddressModal />)}
            {contextValues.toggleAddressListModal && (<AddressListModal></AddressListModal>)}
            {contextValues.toggleTimeSlotModal && (<TimeSlotModal></TimeSlotModal>)}
            {contextValues.toggleCartMenuItems && <CartMenuItemsModal />}
        </>
    )
}
export default Checkout